import { Button } from '@agms/ui'
import type { Application, Lead } from '../../../lib/api'
import { SectionBody, SectionHeader } from './StageContextLayout'

export function NewBusinessContext({ lead, app, onNavigate }: { lead: Lead; app?: Application | null; onNavigate: (p: string) => void }) {
  const hasApp = !!app
  return (
    <>
      <SectionHeader color="#f3f4f6">
        <h3 style={{ fontSize: '15px', fontWeight: 600, color: '#374151' }}>New Business</h3>
      </SectionHeader>
      <SectionBody>
        <p style={{ fontSize: '14px', color: '#6b7280', marginBottom: '16px' }}>
          {hasApp
            ? `TurboApp is on Step ${app!.current_step} of 7. Complete all steps, then send for signature.`
            : 'Start the TurboApp wizard to begin the merchant application process.'}
        </p>
        <Button onClick={() => onNavigate(`/leads/${lead.id}/application`)}>
          {hasApp ? `Continue TurboApp (Step ${app!.current_step})` : 'Start TurboApp'}
        </Button>
      </SectionBody>
    </>
  )
}
